import type { AppData } from "@/types";

// Datos de demostración (opcionales) para previsualizar el ecosistema.
// El estado inicial del sistema permanece LIMPIO; esto solo se carga al pulsar
// "Cargar datos de demostración".

export const buildDemoData = (): AppData => {
  const now = new Date();
  const year = now.getFullYear();
  const at = (month: number, day: number) => new Date(year, month, day, 10, 0, 0).toISOString();

  const products = [
    { id: "p1", sku: "AMW-1101", name: "Artistry Skin Nutrition Conjunto", category: "Belleza", pv: 32, costBase: 415000, pricePublic: 549000 },
    { id: "p2", sku: "AMW-1204", name: "Artistry Crème Luxury Labial", category: "Belleza", pv: 9, costBase: 92000, pricePublic: 122000 },
    { id: "p3", sku: "AMW-2101", name: "SA8 Detergente Ropa 1kg", category: "Hogar", pv: 11, costBase: 68000, pricePublic: 89000 },
    { id: "p4", sku: "AMW-2110", name: "Amway Home LOC Multiusos 1L", category: "Hogar", pv: 8, costBase: 46000, pricePublic: 61000 },
    { id: "p5", sku: "AMW-2140", name: "Amway Home Pursue Desinfectante", category: "Hogar", pv: 7, costBase: 39000, pricePublic: 52000 },
    { id: "p6", sku: "AMW-3101", name: "Nutrilite Doble X 30 días", category: "Nutrición", pv: 45, costBase: 512000, pricePublic: 679000 },
    { id: "p7", sku: "AMW-3120", name: "Nutrilite Proteína Vegetal 450g", category: "Nutrición", pv: 22, costBase: 195000, pricePublic: 259000 },
    { id: "p8", sku: "AMW-3145", name: "Nutrilite Vitamina C Liberación", category: "Nutrición", pv: 12, costBase: 98000, pricePublic: 129000 },
    { id: "p9", sku: "AMW-3170", name: "Nutrilite Omega 3 Ácidos Grasos", category: "Nutrición", pv: 16, costBase: 142000, pricePublic: 188000 },
    { id: "p10", sku: "AMW-3190", name: "Nutrilite Calcio Magnesio 180", category: "Nutrición", pv: 14, costBase: 118000, pricePublic: 156000 },
    { id: "p11", sku: "AMW-4101", name: "G&H Body Wash Refrescante", category: "Aseo Personal", pv: 6, costBase: 32000, pricePublic: 43000 },
    { id: "p12", sku: "AMW-4120", name: "Satinique Champú Fortalecedor", category: "Aseo Personal", pv: 7, costBase: 38000, pricePublic: 51000 },
    { id: "p13", sku: "AMW-4150", name: "Glister Crema Dental Herbal", category: "Aseo Personal", pv: 5, costBase: 27000, pricePublic: 36000 },
    { id: "p14", sku: "AMW-4160", name: "Glister Enjuague Bucal 300ml", category: "Aseo Personal", pv: 5, costBase: 30000, pricePublic: 40000 },
    { id: "p15", sku: "AMW-4190", name: "G&H Gel de Baño Hidratante", category: "Aseo Personal", pv: 6, costBase: 34000, pricePublic: 45000 },
    { id: "p16", sku: "AMW-1108", name: "Artistry Hydra-V Crema Facial", category: "Belleza", pv: 18, costBase: 168000, pricePublic: 222000 },
    { id: "p17", sku: "AMW-1120", name: "Artistry Serum Iluminador", category: "Belleza", pv: 21, costBase: 210000, pricePublic: 279000 },
    { id: "p18", sku: "AMW-2130", name: "Amway Home Jabón Líquido Manos", category: "Hogar", pv: 4, costBase: 24000, pricePublic: 32000 },
  ] as AppData["products"];

  const distributors = [
    {
      id: "d1", names: "Pepito", surnames: "Jiménez", cedula: "1020456789", phone: "3001112233",
      email: "pepito.jimenez@attd.app", address: "Calle 45 #12-30", city: "Bogotá",
      margin: 25 as const, consignmentLimit: 3000000,
      reference: { name: "María Jiménez", relationship: "Madre", phone: "3104445566", city: "Bogotá" },
      createdAt: at(0, 12),
    },
    {
      id: "d2", names: "Danita", surnames: "Rojas", cedula: "1030778899", phone: "3019998877",
      email: "danita.rojas@attd.app", address: "Carrera 8 #22-11", city: "Medellín",
      margin: 25 as const, consignmentLimit: 2500000,
      reference: { name: "Carlos Rojas", relationship: "Hermano", phone: "3123334455", city: "Medellín" },
      createdAt: at(1, 3),
    },
    {
      id: "d3", names: "Laura", surnames: "Gómez", cedula: "1098223344", phone: "3025556677",
      email: "laura.gomez@attd.app", address: "Av. 68 #90-05", city: "Cali",
      margin: 20 as const, consignmentLimit: 1800000,
      reference: { name: "Andrés Gómez", relationship: "Esposo", phone: "3147778899", city: "Cali" },
      createdAt: at(2, 19),
    },
  ] as AppData["distributors"];

  const clients = [
    { id: "c1", name: "Rosa Martínez", cedula: "51882233", phone: "3150001122", address: "Barrio Kennedy" },
    { id: "c2", name: "Jorge Peña", cedula: "79445566", phone: "3160003344", address: "Barrio Modelia" },
    { id: "c3", name: "Familia Torres", cedula: "41778899", phone: "3170005566", address: "Barrio Villa Luz" },
    { id: "c4", name: "Diana Cruz", cedula: "1022334455", phone: "3180007788", address: "Conjunto Altos" },
    { id: "c5", name: "Marta Sarmiento", cedula: "52778811", phone: "3190009900", address: "Barrio Prado" },
  ] as AppData["clients"];

  const sales = [
    { productId: "p6", clientIdx: 0, advisor: "d1", qty: 1, month: 0, day: 18, type: "Full" as const, origin: "Facebook" as const, delivery: "domicilio" as const },
    { productId: "p1", clientIdx: 2, advisor: "d2", qty: 1, month: 0, day: 22, type: "Consignación" as const, origin: "TikTok" as const, delivery: "recojo" as const },
    { productId: "p3", clientIdx: 1, advisor: "admin", qty: 3, month: 1, day: 8, type: "Full" as const, origin: "Casa" as const, delivery: "domicilio" as const },
    { productId: "p7", clientIdx: 3, advisor: "d1", qty: 2, month: 1, day: 15, type: "Full" as const, origin: "Google" as const, delivery: "domicilio" as const },
    { productId: "p7", clientIdx: 4, advisor: "d2", qty: 1, month: 2, day: 5, type: "Consignación" as const, origin: "Facebook" as const, delivery: "recojo" as const },
    { productId: "p6", clientIdx: 2, advisor: "d3", qty: 1, month: 2, day: 27, type: "Full" as const, origin: "TikTok" as const, delivery: "domicilio" as const },
    { productId: "p9", clientIdx: 0, advisor: "d1", qty: 2, month: 3, day: 14, type: "Full" as const, origin: "Facebook" as const, delivery: "domicilio" as const },
    { productId: "p4", clientIdx: 1, advisor: "admin", qty: 4, month: 4, day: 2, type: "A Costo" as const, origin: "Casa" as const, delivery: "recojo" as const },
    { productId: "p17", clientIdx: 3, advisor: "d2", qty: 1, month: 5, day: 21, type: "Full" as const, origin: "TikTok" as const, delivery: "domicilio" as const },
    { productId: "p6", clientIdx: 4, advisor: "d1", qty: 2, month: 6, day: 9, type: "Full" as const, origin: "Google" as const, delivery: "domicilio" as const },
    { productId: "p10", clientIdx: 0, advisor: "admin", qty: 3, month: 7, day: 16, type: "Full" as const, origin: "Casa" as const, delivery: "domicilio" as const },
    { productId: "p1", clientIdx: 2, advisor: "d3", qty: 1, month: 8, day: 4, type: "Consignación" as const, origin: "Facebook" as const, delivery: "domicilio" as const },
    { productId: "p7", clientIdx: 1, advisor: "d2", qty: 3, month: 8, day: 26, type: "Full" as const, origin: "TikTok" as const, delivery: "domicilio" as const },
    { productId: "p6", clientIdx: 3, advisor: "d1", qty: 1, month: 9, day: 6, type: "Full" as const, origin: "Facebook" as const, delivery: "domicilio" as const },
    { productId: "p9", clientIdx: 4, advisor: "admin", qty: 2, month: 9, day: 9, type: "Full" as const, origin: "Google" as const, delivery: "recojo" as const },
  ] as const;

  const salesList = sales.map((s, i) => {
    const product = products.find((p) => p.id === s.productId)!;
    const client = clients[s.clientIdx];
    const distributor = distributors.find((d) => d.id === s.advisor);
    const margin = distributor ? distributor.margin : 25;
    return {
      id: `s${i + 1}`,
      date: at(s.month, s.day),
      clientId: client.id,
      clientName: client.name,
      productId: product.id,
      productName: product.name,
      qty: s.qty,
      pv: s.qty * product.pv,
      total: s.qty * product.pricePublic,
      marginPct: margin,
      advisorId: s.advisor,
      type: s.type,
      origin: s.origin,
      delivery: s.delivery,
    };
  });

  const inventory = products.map((p, i) => ({
    productId: p.id,
    stockCasa: (i % 3) + 2,
    stockPuntoClear: i % 2 === 0 ? 3 : 0,
    stockByAdvisor: {
      d1: (i % 4) + 1,
      d2: i % 3 === 0 ? 2 : 0,
      d3: i % 5 === 0 ? 1 : 0,
    },
    stockOwnedByAdvisor: {
      d1: i % 6 === 0 ? 1 : 0,
      d2: 0,
      d3: 0,
    },
  }));

  const advisorMovements: AppData["advisorMovements"] = [
    { id: "mv1", advisorId: "d1", productId: "p6", productName: "Nutrilite Doble X 30 días", kind: "consignacion", qty: 2, unitValue: 509250, amount: 1018500, note: "Entrega inicial", date: at(9, 1) },
    { id: "mv2", advisorId: "d1", productId: "p6", productName: "Nutrilite Doble X 30 días", kind: "venta", qty: 1, unitValue: 509250, amount: 509250, note: "", date: at(9, 6) },
    { id: "mv3", advisorId: "d2", productId: "p1", productName: "Artistry Skin Nutrition Conjunto", kind: "compra", qty: 1, unitValue: 411750, amount: 411750, note: "Compra directa", date: at(9, 3) },
    { id: "mv4", advisorId: "d1", productId: "", productName: "", kind: "pago", qty: 0, unitValue: 0, amount: 300000, note: "Abono a la cuenta", date: at(9, 8) },
  ];

  const expenses: AppData["expenses"] = [
    { id: "e1", date: at(9, 2), concept: "Donación fundación", category: "Donación", wallet: "Nequi", amount: 120000, note: "", kind: "operativo", status: "pagado", paidAmount: 120000, fund: "donacion" },
    { id: "e2", date: at(9, 5), concept: "Pauta publicitaria Facebook", category: "Gasto operativo", wallet: "Bancolombia", amount: 250000, note: "", kind: "operativo", status: "pagado", paidAmount: 250000, fund: null },
    { id: "e3", date: at(9, 7), concept: "Caja menor domicilios", category: "Caja menor", wallet: "Efectivo", amount: 80000, note: "", kind: "operativo", status: "pagado", paidAmount: 80000, fund: "caja" },
  ];

  const receivables = [
    { id: "r1", date: at(8, 2), clientName: "Rosa Martínez", productName: "Nutrilite Doble X", initialValue: 679000, payments: [{ amount: 200000, date: at(8, 20) }] },
    { id: "r2", date: at(8, 18), clientName: "Jorge Peña", productName: "Artistry Serum Iluminador", initialValue: 279000, payments: [{ amount: 100000, date: at(8, 30) }, { amount: 50000, date: at(9, 5) }] },
    { id: "r3", date: at(9, 4), clientName: "Familia Torres", productName: "SA8 Detergente + LOC", initialValue: 150000, payments: [] },
  ];

  const loans = [
    { id: "l1", date: at(7, 20), concept: "Préstamo liquidez pedido Nutrilite", value: 800000, type: "Préstamo" as const },
    { id: "l2", date: at(8, 12), concept: "Devolución a Juank.unlimited", value: 350000, type: "Devolución" as const },
  ];

  const promotions = [
    { id: "pr1", title: "Combo Doble X + Proteína", description: "Lleva Doble X y Proteína Nutrilite con descuento especial de temporada.", discountPct: 12, startDate: at(9, 1), endDate: at(10, 1), createdAt: at(9, 1) },
    { id: "pr2", title: "Semana Artistry Belleza", description: "20% en toda la línea Artistry para clientas nuevas.", discountPct: 20, startDate: at(9, 10), endDate: at(9, 30), createdAt: at(9, 9) },
  ];

  return {
    products,
    distributors,
    clients,
    sales: salesList,
    inventory,
    advisorMovements,
    expenses,
    receivables,
    loans,
    promotions,
    encargos: [],
    restockItems: [],
    notifications: [
      { id: "n1", audience: "admin", title: "Venta chuleada por Pepito Jiménez", message: "Nutrilite Doble X · 1 und", kind: "sale", date: at(9, 6), read: false },
      { id: "n2", audience: "admin", title: "Pedido por encargo recibido", message: "Diana Cruz solicitó Artistry Serum", kind: "order", date: at(9, 8), read: false },
      { id: "n3", audience: "asesor", title: "Nueva promoción disponible", message: "Semana Artistry Belleza · -20%", kind: "promo", date: at(9, 9), read: false },
      { id: "n4", audience: "admin", title: "Reposición para el sábado", message: "3 productos fueron marcados como vendidos", kind: "info", date: at(9, 10), read: true },
    ],
    settings: {
      logisticsFee: 12000,
      distribution: { donation: 2, advisor: 5, reinvestment: 13, management: 5 },
      titleStyle: { font: "Sora", color: "#FFFFFF", glow: true },
      walletBalances: { Bancolombia: 0, Daviplata: 0, Nequi: 0, "Caja Social": 0, Efectivo: 0 },
      logoUrl: "",
      kitItems: [],
      fundMovements: [],
    },
    period: { year, month: 9 },
    role: "admin",
  };
};